// extracted by css-extract-rspack-plugin
export default {"detailIcon":"F4KqjLpAX40H27xk","detailCollection":"zSnvCJx28MeLuV4Q","issueCountLabel":"WzNDFmra9oouar_J","count":"Pj56lCFi6vEjrZ1u"};